"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
const flatAppUser = (user, startFlattedUser) => {
    let flattedUser = (startFlattedUser && Object.assign({}, startFlattedUser)) || Object.assign({}, user);
    flattedUser.providerData = undefined;
    if (startFlattedUser) {
        (0, index_1.copyPropsIfDefined)(startFlattedUser, flattedUser, [
            'displayName', 'phoneNumber', 'photoURL', 'email',
        ]);
    }
    if (!user.providerData) {
        return flattedUser;
    }
    user.providerData.forEach((providerUser) => {
        if (providerUser
            && (!flattedUser.displayName
                || !flattedUser.phoneNumber
                || !flattedUser.photoURL
                || !flattedUser.email)) {
            flattedUser = flatAppUser(flattedUser, Object.assign(Object.assign({}, providerUser), { updatePassword: user.updatePassword }));
        }
    });
    return flattedUser;
};
exports.default = flatAppUser;
